<template>
    <el-container>
        <el-header>
            <div class="testpaper-title">{{testInfo.name}} ( {{testInfo.totalScore}}分 )</div>
            <div class="testpaper-status">
                <el-tag style="font-size:20px;font-weight: bolder" v-if="!testInfo.isFinished && testInfo.limitTime">剩余时间 : {{timeCountStr}}</el-tag>
                <div style="color: #606266;font-size:22px;font-weight: bolder;display: flex;align-items: center" v-if="testInfo.isFinished">
                    <span style="margin-right: 10px">考试结束, 得分：{{testInfo.score}} 分</span>
                    <el-tag type="success" size="small" v-if="testInfo.isPass === '1'">合格</el-tag>
                    <el-tag type="danger" size="small" v-else>不合格</el-tag>
                </div>
            </div>
        </el-header>
        <el-main>
            <div class="testpaper-container">
                <!--测试中的题目选择器-->
                <el-card class="box-card" v-if="!testInfo.isFinished">
                    <div slot="header" class="clearfix">
                        <el-row class="item-card-row">
                            <el-col>
                                自动切换 :
                                <el-tooltip class="item" effect="dark" content="开启后自动切换到下一题" placement="bottom-start">
                                    <el-switch v-model="isAutoNextItem" active-color="#67C23A"  inactive-color="#C0C4CC"></el-switch>
                                </el-tooltip>
                            </el-col>
                        </el-row>
                        <el-row  style="margin-bottom: 10px">完成率 :</el-row>
                        <el-row class="item-card-row">
                            <el-col :offset="1"><el-progress :stroke-width="7" :percentage="completionRate" color="#67c23a"></el-progress></el-col>
                        </el-row>
                        <el-row :gutter="10">
                            <el-col :span="4" v-if="testInfo.testItemList" v-for="(item, index) in testInfo.testItemList">
                                <div :id="testCardItemPre + (index + 1)" class="item-index" @click="goToItemWhenDoing(index + 1)">{{index + 1}}</div>
                            </el-col>
                        </el-row>
                    </div>
                    <el-row type="flex" justify="center">
                        <el-col>
                            <el-button type="primary" size="medium" style="width: 100%" @click="confirmSubmitTest" icon="el-icon-finished">交卷</el-button>
                        </el-col>
                    </el-row>
                </el-card>

                <!--已完成测试时的题目选择器-->
                <el-card class="box-card" v-if="testInfo.isFinished">
                    <div slot="header" class="clearfix">
                        <el-row>
                            <el-col>正确率：</el-col>
                        </el-row>
                        <el-row class="item-card-row" type="flex" justify="center">
                            <el-col :span="15">
                                <el-progress type="circle" :width="120" :stroke-width="10" :percentage="testInfo.rightRate" color="#67c23a"></el-progress>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col>用时：{{testInfo.useTime}}</el-col>
                        </el-row>
                    </div>
                    <el-row :gutter="10">
                        <el-col :span="4" v-if="testInfo.testItemList" v-for="(item, index) in testInfo.testItemList">
                            <div :id="testCardItemPre + (index + 1)"
                                 :class="[{'item-index': true}, {'item-card-right': item.isRight === '1'}, {'item-card-wrong': item.isRight === '0'}]"
                                 @click="goToItemWhenFinish(index + 1)">{{index + 1}}</div>
                        </el-col>
                    </el-row>
                    <el-row type="flex" justify="center" style="padding-top: 20px">
                        <el-col>
                            <el-button size="medium" style="width: 100%" @click="goBack" icon="el-icon-back">返回</el-button>
                        </el-col>
                    </el-row>
                </el-card>

                <!--试卷域-->
                <!--测试中的试卷域-->
                <div class="testpaper-content" v-if="!testInfo.isFinished">
                    <!--题干信息-->
                    <el-row class="item-row">
                        <el-col :id="testItemPre + (currentItemIndex+1)">
                            {{currentItemIndex+1}}、({{getItemTypeName(currentItem.type)}} {{currentItem.score}}分) {{currentItem.stem}}
                        </el-col>
                    </el-row>
                    <el-row>
                        <!--单选题-->
                        <el-col v-if="currentItem.type === 'SINGLE_CHOICE' && currentItem.optionList.length > 0">
                            <el-radio-group v-model="currentItem.userAnswer"  @change="changeItem(currentItem.type)">
                                <el-radio :label="index + ''" v-for="(option, index) in currentItem.optionList" style="display: block;margin-bottom: 15px">{{option}}</el-radio>
                            </el-radio-group>
                        </el-col>
                        <!--多选题-->
                        <el-col v-if="currentItem.type === 'MULTI_CHOICE' && currentItem.optionList.length > 0">
                            <el-checkbox-group v-model="currentItem.userAnswer" @change="changeItem(currentItem.type)">
                                <el-checkbox :label="index + ''" v-for="(option, index) in currentItem.optionList" style="display: block;margin-bottom: 15px">{{option}}</el-checkbox>
                            </el-checkbox-group>
                        </el-col>
                    </el-row>
                    <el-row type="flex" justify="end" class="item-choose-btn">
                        <el-button-group>
                            <el-button icon="el-icon-arrow-left" @click="--currentItemIndex" :disabled="currentItemIndex <= 0">上一题</el-button>
                            <el-button @click="++currentItemIndex" :disabled="currentItemIndex >= (testInfo.testItemList.length -1)">下一题<i class="el-icon-arrow-right el-icon--right"></i></el-button>
                        </el-button-group>
                    </el-row>
                </div>

                <!--已完成时的试卷域-->
                <div class="testpaper-content" v-if="testInfo.isFinished">
                    <div v-if="testInfo.testItemList" v-for="(item, index) in testInfo.testItemList">
                        <!--题干信息-->
                        <el-row class="item-row-finished">
                            <el-col :id="testItemPre + (index+1)">
                                <i v-if="item.isRight" :class="[item.isRight === '1' ? 'el-icon-check item-right' : 'el-icon-close item-wrong']"></i>
                                {{index+1}}、({{getItemTypeName(item.type)}} {{item.score}}分) {{item.stem}}
                            </el-col>
                        </el-row>
                        <el-row>
                            <!--单选题-->
                            <el-col v-if="item.type === 'SINGLE_CHOICE' && item.optionList.length > 0">
                                <el-radio-group v-model="item.userAnswer" disabled>
                                    <el-radio :label="index + ''" v-for="(option, index) in item.optionList">{{option}}</el-radio>
                                </el-radio-group>
                            </el-col>
                            <!--多选题-->
                            <el-col v-if="item.type === 'MULTI_CHOICE' && item.optionList.length > 0">
                                <el-checkbox-group v-model="item.userAnswer" disabled>
                                    <el-checkbox :label="index + ''" v-for="(option, index) in item.optionList">{{option}}</el-checkbox>
                                </el-checkbox-group>
                            </el-col>
                        </el-row>
                        <!--答案-->
                        <!--<div style="text-align: right">
                            <el-tag type="info">答案: {{item.answerStr}}</el-tag>
                        </div>-->
                        <el-divider></el-divider>
                    </div>
                </div>
            </div>
        </el-main>
    </el-container>
</template>

<script>
    export default {
        name: "Test",
        data() {
            return {
                testInfo: {
                    id: '',
                    name: '',
                    limitTime: '',
                    totalScore: '',

                    isFinished: false, //是否已完成试卷
                    score: '',
                    useTime: '',
                    isPass: '',
                    rightRate: '',

                    testItemList: [],
                },
                courseId: '', //课程id
                sectionId: '', //小节id

                testItemPre : 'testItem',
                testCardItemPre : 'testCardItem',

                currentItemIndex: 0,
                currentItem: '',
                isAutoNextItem: false,
                timeCount: 0,
                timeCountStr: '',
                timer: '',
                completionRate: 0,

                fromRouterPath: '',
            }
        },
        methods: {
            getItemTypeName(value) {
                if (value === 'SINGLE_CHOICE') {
                    return '单选题';
                } else if (value === 'MULTI_CHOICE') {
                    return '多选题' // 多选题的答案顺序是按照选择的顺序..
                }
                return '';
            },
            /**
             * 设置倒计时
             */
            setTimeCount() {
                this.timeCount = this.testInfo.limitTime;
                this.timeCountStr =  Tool.formatSeconds(this.timeCount--);
                this.timer = setInterval(() => {
                    if (this.timeCount < 0) {
                        clearInterval(this.timer);
                        this.submitTest();
                        return;
                    }
                    this.timeCountStr =  Tool.formatSeconds(this.timeCount--);
                }, 1000);
            },
            /**
             * 试题锚点
             */
            goToItemWhenDoing(index) {
                this.currentItemIndex = --index;
                this.currentItem = this.testInfo.testItemList[this.currentItemIndex];
            },
            goToItemWhenFinish(index) {
                document.querySelector('#' + this.testItemPre + index).scrollIntoView(true);
            },
            /**
             * 做了某道题
             */
            changeItem(itemType) {
                this.countCompletionRate();
                this.autoNextItem(itemType);
            },
            /**
             * 自动切换下一题
             */
            autoNextItem(itemType){
                if (this.isAutoNextItem
                    && this.currentItemIndex < (this.testInfo.testItemList.length -1)
                    && itemType !== 'MULTI_CHOICE') {
                    ++this.currentItemIndex; //watch会监听
                }
            },
            /**
             * 计算完成率
             */
            countCompletionRate() {
                const itemCountAll =  this.testInfo.testItemList.length;
                let compleCount = 0;
                for (let i = 0; i < itemCountAll; i++) {
                    const userAnswer = this.testInfo.testItemList[i].userAnswer;
                    const itemEle = document.getElementById(this.testCardItemPre + (i + 1));
                    // 不能直接if(userAnswer)...
                    if ((userAnswer instanceof Array && userAnswer.length > 0)
                        || (typeof(userAnswer) === 'string' && userAnswer)) {
                        compleCount++;

                        itemEle.setAttribute("style","color: white;background-color: #67C23A");
                    } else {
                        itemEle.setAttribute("style", "");
                    }
                }
                this.completionRate = (compleCount / itemCountAll).toFixed(2) * 100;
            },
            /**
             * 获取试卷信息
             */
            async getTestInfo(params) {
                const { content } = await this.$http.post('/business/web/test/getTestInfo', params);
                if (content) {
                    this.testInfo = content;
                    const itemList = this.testInfo.testItemList;
                    if (itemList) {
                        itemList.forEach(item => {
                            // 分隔选项
                            const optionList = []; // 格式: [ "A.选项A内容", "B.选项B内容" ]
                            const optionsContent = JSON.parse(item.options); // 格式: { A: "选项A内容", B: "选项B内容" }
                            Object.keys(optionsContent).map(key => {
                                optionList.push(key + '.' + optionsContent[key]);
                            });
                            item.optionList = optionList;

                            // 多选题的用户答案初始
                            if (item.type === 'MULTI_CHOICE') {
                                item.userAnswer = this.testInfo.isFinished ? item.userAnswer.split(',') : [];
                            }
                        })
                    }

                }
            },
            /**
             * 提交试卷
             */
            async confirmSubmitTest() {
                if (!this.testInfo.id) {
                    this.$message.error("提交失败, 无任何试卷信息 !"); return;
                }
                this.$confirm('是否提交试卷, 一旦确定无法再修改', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: true,
                }).then(async () => {
                    clearInterval(this.timer);
                    await this.submitTest();
                }).catch(() => { });
            },
            async submitTest() {
                // 组装用户答案List
                const userAnswerList = [];
                this.testInfo.testItemList.forEach(item => {
                    if (item.type === 'MULTI_CHOICE') { // 用户多选题答案排序
                        item.userAnswer = item.userAnswer.length > 0 ? item.userAnswer.sort().join(',') : null;
                    }
                    userAnswerList.push({testItemId: item.id, userAnswer: item.userAnswer, userId: this.$store.state.userInfo.id});
                });
                const params = {
                    sectionId: this.sectionId,
                    courseId: this.courseId,
                    testId: this.testInfo.id,
                    userId: this.$store.state.userInfo.id,
                    useTime: this.testInfo.limitTime ? this.testInfo.limitTime - this.timeCount - 1 : null, //应交给后台算
                    userAnswerList: userAnswerList,
                };
                const { success, content } = await this.$http.post('/business/web/test/submitTest', params);
                if (success) {
                    this.$message({ type: 'success', message: '提交成功!' });
                    if (content === '1') { // 合格后获取答题结果
                        const params = {
                            courseId: this.courseId, sectionId: this.sectionId, testId: this.testInfo.id
                        }
                        await this.getTestInfo(params);
                    } else { //不合格则跳回章节目录
                        this.goBack();
                    }
                }
            },
            goBack() {
                //this.$router.push({path: this.fromRouterPath});
                this.$router.back();
            }
        },
        async created() {
            this.courseId = this.$route.params.courseId;
            this.sectionId = this.$route.params.sectionId;
            await this.getTestInfo(this.$route.params); //params: 课程id、小节id、试卷id

            this.currentItem = this.testInfo.testItemList[0];
            // 设置倒计时
            if (!this.testInfo.isFinished && this.testInfo.limitTime) {
                this.setTimeCount();
            }
        },
        watch: {
            currentItemIndex(newVal, oldVal) {
                this.currentItem = this.testInfo.testItemList[newVal];
            }
        },
        beforeDestroy() {
            clearInterval(this.timer);
        },
        /*beforeRouteEnter (to, from, next) {
            next(vm => {
                if (from.path){
                    console.log(vm.fromRouterPath);
                    vm.fromRouterPath = from.path;
                    console.log(from.path);

                }
            })
        }*/
    }
</script>

<style lang="scss" scoped>
    .el-header {
        background-color: white;
        box-shadow: 0 4px 10px 0 hsla(240,3%,61%,.2);
        z-index: 999;
    }

    .el-container {
        width: 100%;
        height: 100%;
        background-color: #f8f9fa;
    }

    .testpaper-container {
        position: relative;
        margin:10px auto;
        right: 70px;
        width: 800px;
        min-height: 400px;
        background-color: white;
        border-radius: 3px 3px 3px 3px;
        box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    }

    .el-card {
        position: fixed;
        left: calc(50% + 350px);
        width: 220px;
        z-index: 10;
    }

    .testpaper-title {
        float: left;
        font-size: 18px;
        padding: 16px 0 0 150px;
    }

    .testpaper-content {
        margin: 0 20px 0;
        padding: 25px 10px 70px;
    }

    .testpaper-status  {
        float: right;
        margin: 15px 150px 0 0;
    }

    .item-choose-btn {
        position: absolute;
        bottom: 20px;
        right: 20px;
    }

    .el-divider {
        margin: 15px 0;
    }

    .item-row {
        margin-bottom: 60px;
    }
    .item-row-finished {
        margin-bottom: 30px;
    }

    .item-card-row {
        margin-bottom: 20px;
    }

    .el-radio-group {
        margin-right: 30px;
    }

    .el-checkbox-group {
        display:inline;
        margin-right: 30px;
    }

    .item-right {
        color: #67C23A;
        font-weight: bold;
        margin-right: 10px
    }
    .item-wrong {
        color: #F56C6C;
        font-weight: bold;
        margin-right: 10px
    }

    .item-card-right {
        color: white;
        background-color: #67C23A;
    }
    .item-card-wrong {
        color: white;
        background-color: #F56C6C;
    }

    .el-radio {
        &:hover {
            color: #409EFF;
        }
    }

    .el-checkbox {
        &:hover {
            color: #409EFF;
        }
    }

    .item-index {
        width: 23px;
        height: 23px;
        margin-bottom: 8px;
        font-size: 14px;
        text-align: center;
        line-height: 25px;
        border: 1px solid #dddddd;
        cursor: pointer;

        &:hover {
            color: black;
            background-color: rgb(233, 233, 235);
        }
    }

    /deep/ .el-progress--circle .el-progress__text {
        font-size: 20px !important;
    }
</style>
